export enum EDiagnosisContactType {
  NonF2F = 'NON_F2F',
  F2F = 'F2F',
}
